import { invokeApi } from "../../bl_libs/invokeApi";

/** Public join — load tracker by slug (no auth). */
export const getPublicTrackerDetailApi = async (slug) => {
  const requestObj = {
    path: `/api/tracker/public/${encodeURIComponent(slug)}`,
    method: "GET",
  };
  return invokeApi(requestObj);
};

/**
 * Public join — submit answers by slug.
 * Optional member token → backend tags gymrite_member when logged in.
 */
export const submitPublicTrackerApi = async (slug, data = {}) => {
  const token = localStorage.getItem("token");
  const headers = {};
  if (token) {
    headers["x-sh-auth"] = token;
  }

  const requestObj = {
    path: `/api/tracker/public/${encodeURIComponent(slug)}/submissions`,
    method: "POST",
    headers,
    postData: {
      password: data.password || "",
      formId: data.formId || "",
      answers: data.answers || {},
    },
  };
  return invokeApi(requestObj);
};

export const getTrackerSubmissionsApi = async (
  trackerId,
  {
    page = 1,
    limit = 50,
    search = "",
    source = "",
    review = "",
    status = "",
    coach = "",
  } = {}
) => {
  const queryParams = [];
  if (page) queryParams.push(`page=${encodeURIComponent(page)}`);
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
  if (source && source !== "all")
    queryParams.push(`source=${encodeURIComponent(source)}`);
  if (review && review !== "all")
    queryParams.push(`review=${encodeURIComponent(review)}`);
  if (status && status !== "all")
    queryParams.push(`status=${encodeURIComponent(status)}`);
  if (coach && coach !== "all")
    queryParams.push(`coach=${encodeURIComponent(coach)}`);

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
  const path = trackerId
    ? `/api/tracker/${trackerId}/submissions${queryString}`
    : `/api/tracker_submission${queryString}`;

  const requestObj = {
    path,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const getTrackerSubmissionDetailApi = async (id) => {
  const requestObj = {
    path: `/api/tracker_submission/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const deleteTrackerSubmissionApi = async (id) => {
  const requestObj = {
    path: `/api/tracker_submission/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const markTrackerSubmissionSeenApi = async (id) => {
  const requestObj = {
    path: `/api/tracker_submission/${id}/seen`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const updateTrackerSubmissionApi = async (id, data = {}) => {
  const requestObj = {
    path: `/api/tracker_submission/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
